module.exports = __webpack_public_path__ + "static/img/sd_light.a5dcdf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/sd_light.png
// module id = JNoa
// module chunks = 1